import React, { useEffect, useState } from "react";
import axios from "../../utils/axios";
import { Link, useNavigate } from "react-router-dom";
import { base_url } from "../../utils/axiosConfig";

/* ─────────────────────────────────────────────────────────────────
   STYLES – scoped with .mm- prefix so nothing bleeds out
───────────────────────────────────────────────────────────────── */
const MEGA_STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');

  @keyframes mmPanelIn {
    from { opacity: 0; transform: translateY(-10px) scale(0.98); }
    to   { opacity: 1; transform: translateY(0)    scale(1);    }
  }

  /* ── Panel shell ── */
  .mm-panel {
    display: flex;
    background: #ffffff;
    width: 100%;
    font-family: 'Inter', sans-serif;
    animation: mmPanelIn 0.2s ease;
    border-bottom: 3px solid #14b8a6;
    box-shadow: 0 15px 35px rgba(0,0,0,0.12);
  }

  /* ── LEFT SIDEBAR ── */
  .mm-sidebar {
    width: 220px;
    flex-shrink: 0;
    background: #f8fafc;
    border-right: 1px solid #f1f5f9;
    overflow-y: auto;
    max-height: 480px;
    scrollbar-width: none;
    -ms-overflow-style: none;
    padding-bottom: 12px;
  }
  .mm-sidebar::-webkit-scrollbar { display: none; }

  @media (max-width: 768px) {
    .mm-panel { flex-direction: column; max-height: 85vh; overflow-y: auto; }
    .mm-sidebar { 
      width: 100%; 
      height: auto; 
      max-height: none;
      display: flex; 
      overflow-x: auto; 
      overflow-y: hidden;
      border-right: none; 
      border-bottom: 1px solid #f1f5f9;
      padding: 0 10px;
      gap: 0;
      scrollbar-width: none;
    }
    .mm-sidebar::-webkit-scrollbar { display: none; }
    .mm-sidebar-head { display: none; }
    .mm-cat-item { 
      padding: 12px 16px; 
      border-left: none; 
      border-bottom: 3px solid transparent;
      white-space: nowrap;
      flex-shrink: 0;
      justify-content: center;
    }
    .mm-cat-item.active { border-bottom-color: #14b8a6; border-left-color: transparent; }
    .mm-cat-item:hover { border-bottom-color: #14b8a6; border-left-color: transparent; }
    .mm-cat-chevron { display: none; }
    .mm-content { max-height: none !important; padding: 16px; width: 100%; }
    .mm-sub-grid { 
      grid-template-columns: repeat(auto-fill, minmax(80px, 1fr)) !important; 
      gap: 8px !important;
    }
    .mm-sub-circle { width: 56px !important; height: 56px !important; }
    .mm-sub-label { font-size: 10px !important; }
  }

  /* sidebar header row */
  .mm-sidebar-head {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 16px 18px 10px;
  }
  .mm-sidebar-head-icon {
    width: 28px; height: 28px;
    border-radius: 8px;
    background: linear-gradient(135deg, #14b8a6, #0d9488);
    display: flex; align-items: center; justify-content: center;
    color: #fff; flex-shrink: 0;
  }
  .mm-sidebar-head-label {
    font-size: 10px;
    font-weight: 900;
    letter-spacing: 0.22em;
    text-transform: uppercase;
    color: #94a3b8;
  }

  /* category row */
  .mm-cat-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 18px 10px 16px;
    cursor: pointer;
    font-size: 13.5px;
    font-weight: 600;
    color: #475569;
    border-left: 3px solid transparent;
    transition: background 0.18s, color 0.18s, border-color 0.18s;
    user-select: none;
  }
  .mm-cat-item:hover {
    background: #f0fdfa;
    color: #14b8a6;
    border-left-color: #14b8a6;
  }
  .mm-cat-item.active {
    background: #f0fdfa;
    color: #14b8a6;
    font-weight: 800;
    border-left-color: #14b8a6;
  }

  .mm-cat-item__left {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  /* colored dot accent on active */
  .mm-cat-dot {
    width: 6px; height: 6px;
    border-radius: 50%;
    background: #e2e8f0;
    flex-shrink: 0;
    transition: background 0.18s;
  }
  .mm-cat-item.active .mm-cat-dot,
  .mm-cat-item:hover .mm-cat-dot { background: #14b8a6; }

  .mm-cat-chevron {
    color: #cbd5e1;
    transition: color 0.18s, transform 0.18s;
    flex-shrink: 0;
  }
  .mm-cat-item.active .mm-cat-chevron,
  .mm-cat-item:hover .mm-cat-chevron {
    color: #14b8a6;
    transform: translateX(2px);
  }

  /* ── RIGHT CONTENT PANEL ── */
  .mm-content {
    flex: 1;
    padding: 20px 28px 24px;
    overflow-y: auto;
    max-height: 420px;
    scrollbar-width: none;
    -ms-overflow-style: none;
    background: #fff;
  }
  .mm-content::-webkit-scrollbar { display: none; }

  /* "SHOP BY WOMEN CATEGORY" header row */
  .mm-content-head {
    display: flex;
    align-items: center;
    gap: 9px;
    margin-bottom: 18px;
    padding-bottom: 14px;
    border-bottom: 1.5px solid #f1f5f9;
  }
  .mm-content-head-icon {
    width: 32px; height: 32px;
    border-radius: 9px;
    background: linear-gradient(135deg, #14b8a6, #0d9488);
    display: flex; align-items: center; justify-content: center;
    color: #fff; flex-shrink: 0;
  }
  .mm-content-head-title {
    font-size: 13px;
    font-weight: 900;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: #14b8a6;
  }

  /* ── SUBCATEGORY CIRCLE GRID ── */
  .mm-sub-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(88px, 1fr));
    gap: 14px 10px;
  }

  /* single subcategory tile */
  .mm-sub-tile {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 8px;
    padding: 8px 4px 10px;
    border-radius: 14px;
    text-decoration: none;
    cursor: pointer;
    transition: background 0.2s, transform 0.2s;
    border: 1.5px solid transparent;
  }
  .mm-sub-tile:hover {
    background: #f0fdfa;
    border-color: rgba(20,184,166,0.15);
    transform: translateY(-3px);
  }

  /* circle image */
  .mm-sub-circle {
    width: 68px;
    height: 68px;
    border-radius: 50%;
    overflow: hidden;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    box-shadow: 0 1px 2px rgba(0,0,0,0.04);
  }
  .mm-sub-tile:hover .mm-sub-circle {
    border-color: #14b8a6;
    transform: translateY(-2px);
    box-shadow: 0 8px 16px rgba(20,184,166,0.12);
  }

  .mm-sub-circle img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.35s ease;
  }
  .mm-sub-tile:hover .mm-sub-circle img { transform: scale(1.1); }

  /* "View All" special circle */
  .mm-sub-circle--all {
    background: linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%);
    border-color: #99f6e4;
  }
  .mm-sub-tile--all:hover .mm-sub-circle--all {
    border-color: #14b8a6;
    box-shadow: 0 0 0 4px rgba(20,184,166,0.18);
  }
  .mm-sub-circle--all-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 3px;
    color: #14b8a6;
  }
  .mm-sub-circle--all-text {
    font-size: 9px;
    font-weight: 900;
    letter-spacing: 0.05em;
    color: #0d9488;
  }

  /* icon placeholder (no image) */
  .mm-sub-circle--icon {
    background: #f8fafc;
  }
  .mm-sub-icon { color: #cbd5e1; }

  /* label below circle */
  .mm-sub-label {
    font-size: 11px;
    font-weight: 700;
    color: #64748b;
    line-height: 1.3;
    max-width: 86px;
    transition: color 0.2s;
    word-break: break-word;
    text-transform: capitalize;
  }
  .mm-sub-tile:hover .mm-sub-label,
  .mm-sub-tile--all:hover .mm-sub-label { color: #0d9488; }

  /* ── SKELETON LOADER ── */
  @keyframes mmShimmer {
    0%   { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }
  .mm-skel-circle {
    width: 70px; height: 70px;
    border-radius: 50%;
    background: linear-gradient(90deg, #f1f5f9 25%, #e8f4f8 50%, #f1f5f9 75%);
    background-size: 200% 100%;
    animation: mmShimmer 1.5s infinite;
  }
  .mm-skel-line {
    border-radius: 6px;
    background: linear-gradient(90deg, #f1f5f9 25%, #e8f4f8 50%, #f1f5f9 75%);
    background-size: 200% 100%;
    animation: mmShimmer 1.5s infinite;
  }
  .mm-skel-cat {
    height: 36px;
    margin: 4px 14px;
    border-radius: 8px;
    background: linear-gradient(90deg, #f1f5f9 25%, #e8f4f8 50%, #f1f5f9 75%);
    background-size: 200% 100%;
    animation: mmShimmer 1.5s infinite;
  }

  /* ── VIEW ALL LINK (footer) ── */
  .mm-view-all-wrap {
    margin-top: 16px;
    padding-top: 14px;
    border-top: 1px solid #f1f5f9;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .mm-view-all-btn {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: 8px 20px;
    background: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%);
    color: #fff;
    font-size: 12px;
    font-weight: 800;
    border-radius: 100px;
    text-decoration: none;
    letter-spacing: 0.08em;
    transition: transform 0.2s, box-shadow 0.2s;
    box-shadow: 0 4px 14px rgba(20,184,166,0.3);
  }
  .mm-view-all-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(20,184,166,0.4);
    color: #fff;
  }
  .mm-count-badge {
    font-size: 11px;
    color: #94a3b8;
    font-weight: 600;
  }

  /* ── EMPTY STATE ── */
  .mm-empty {
    padding: 32px 16px;
    text-align: center;
    color: #94a3b8;
    font-size: 13px;
  }
  .mm-empty-icon { font-size: 32px; margin-bottom: 8px; }
`;

/* ────────────────────────────────────────────────────────────────*/

const getIconForCategory = (title) => {
  const t = (title || "").toLowerCase();
  if (t.includes("medicine")) return "💊";
  if (t.includes("care") || t.includes("baby")) return "🍼";
  if (t.includes("supplement") || t.includes("vitamin")) return "🧪";
  if (t.includes("equipment") || t.includes("monitor")) return "🩺";
  if (t.includes("diagnostic")) return "🔬";
  if (t.includes("formula")) return "🍼";
  if (t.includes("immunity")) return "🛡️";
  return "📦";
};

function Hederdisp({ activeCategoryId }) {
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [activeCategory, setActiveCategory] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [activeCategoryState, setActiveCategoryState] = useState(null);

  // When parent tells us which category to highlight (via hovering nav link), sync it
  useEffect(() => {
    if (activeCategoryId && categories.length > 0) {
      // activeCategoryId might be a _id or a title — pick whichever matches
      const match = categories.find(
        (c) => c._id === activeCategoryId || c.title === activeCategoryId,
      );
      if (match) setActiveCategory(match._id || match.title);
    }
  }, [activeCategoryId, categories]);

  useEffect(() => {
    if (!navigator.onLine) {
      setLoading(false);
      return;
    }
    (async () => {
      try {
        const [catRes, subRes, prodRes] = await Promise.all([
          axios.get(`${base_url}category`).catch(() => ({ data: [] })),
          axios.get(`${base_url}subcategory`).catch(() => ({ data: [] })),
          axios.get(`${base_url}product`).catch(() => ({ data: [] })),
        ]);
        const cats = Array.isArray(catRes.data) ? catRes.data : [];
        const subs = Array.isArray(subRes.data) ? subRes.data : [];
        const prods = Array.isArray(prodRes.data.product)
          ? prodRes.data.product
          : Array.isArray(prodRes.data)
            ? prodRes.data
            : [];

        setCategories(cats);
        setSubcategories(subs);
        setProducts(prods);

        if (cats.length > 0) setActiveCategory(cats[0]._id || cats[0].title);
      } catch (err) {
        console.error("Mega menu fetch error:", err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const activeCatObj = categories.find(
    (c) => (c._id || c.title) === activeCategory,
  );

  const filteredSubs = React.useMemo(() => {
    if (!activeCatObj) return [];

    const targetCatTitle = (activeCatObj.title || activeCatObj.name || "")
      .toLowerCase()
      .trim()
      .replace(/['"]+$/, "");

    // 1. Find subcategory names physically present in products of this category
    const subNamesByProducts = new Set(
      products
        .filter(
          (p) =>
            (p.category || "")
              .toLowerCase()
              .trim()
              .replace(/['"]+$/, "") === targetCatTitle,
        )
        .map((p) => (p.subcategory || "").toLowerCase().trim()),
    );

    // 2. Return the subcategory objects that match those names
    return subcategories.filter((s) => {
      const sTitle = (s.title || "").toLowerCase().trim();
      return subNamesByProducts.has(sTitle);
    });
  }, [activeCatObj, subcategories, products]);

  // Ensuring we show valid data - if filtered is empty but subcats exist,
  // we might be in an "All" state or have a mismatch.
  const displaySubs = filteredSubs;

  const headTitle = activeCatObj
    ? `Shop by ${activeCatObj.title || activeCatObj.name} Category`
    : "Browse All Categories";

  return (
    <>
      <style>{MEGA_STYLES}</style>

      <div className="mm-panel" role="dialog" aria-label="Category mega menu">
        {/* Mobile Header */}
        <div className="mm-mobile-header">
           <span>Browse Categories</span>
        </div>

        <style>{`
          .mm-mobile-header { display: none; }
          @media (max-width: 768px) {
            .mm-mobile-header {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100%;
              padding: 12px 0;
              background: #ffffff;
              border-bottom: 2px solid #f1f5f9;
              font-family: 'Inter', sans-serif;
              font-size: 14px;
              font-weight: 800;
              color: #14b8a6;
              letter-spacing: 0.5px;
              text-transform: uppercase;
            }
            .mm-panel {
              flex-direction: column;
              height: 100%;
              background: #fff;
            }
            .mm-sidebar {
              width: 100%;
              display: flex;
              overflow-x: auto;
              border-right: none;
              background: #f8fafc;
              border-bottom: 1.5px solid #e2e8f0;
              padding: 0 4px;
              height: 52px;
              flex-shrink: 0;
            }
            .mm-cat-item {
              padding: 0 16px;
              height: 52px;
              border-left: none !important;
              border-bottom: 3px solid transparent;
              flex-shrink: 0;
              justify-content: center;
              font-size: 13px;
              color: #64748b;
            }
            .mm-cat-item.active {
              color: #14b8a6;
              border-bottom-color: #14b8a6 !important;
              background: #fff;
            }
            .mm-cat-dot, .mm-cat-chevron, .mm-sidebar-head { display: none !important; }
            .mm-content {
              padding: 20px 16px;
              background: #fff;
              flex: 1;
              max-height: none !important;
            }
          }
        `}</style>

        {/* ── LEFT: Category Sidebar ── */}
        <nav className="mm-sidebar" aria-label="Categories">
          {/* Header */}
          <div className="mm-sidebar-head">
            <div className="mm-sidebar-head-icon">
              {/* grid icon */}
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect width="7" height="7" x="3" y="3" rx="1" />
                <rect width="7" height="7" x="14" y="3" rx="1" />
                <rect width="7" height="7" x="14" y="14" rx="1" />
                <rect width="7" height="7" x="3" y="14" rx="1" />
              </svg>
            </div>
            <span className="mm-sidebar-head-label">Categories</span>
          </div>

          {/* Category rows */}
          {loading ? (
            [1, 2, 3, 4, 5].map((i) => <div key={i} className="mm-skel-cat" />)
          ) : categories.length === 0 ? (
            <div
              style={{ padding: "12px 18px", fontSize: 12, color: "#94a3b8" }}
            >
              No categories
            </div>
          ) : (
            categories.map((cat) => {
              const cid = cat._id || cat.title;
              return (
                <div
                  key={cid}
                  className={`mm-cat-item${activeCategory === cid ? " active" : ""}`}
                  onMouseEnter={() => setActiveCategory(cid)}
                  onClick={() => {
                    const title = cat.title || cat.name;
                    const routes = {
                      "Medicines": "/medicines",
                      "OTC": "/otc",
                      "Vitamins": "/vitamins",
                      "Mother & Baby": "/mother-baby",
                      "Prescription": "/medicines"
                    };
                    if (routes[title]) {
                      navigate(routes[title]);
                    } else {
                      navigate(`/shop?category=${encodeURIComponent(title)}`);
                    }
                  }}
                  role="menuitem"
                  aria-current={activeCategory === cid ? "true" : undefined}
                >
                  <div className="mm-cat-item__left">
                    <span className="mm-cat-dot" />
                    <span>{cat.title || cat.name}</span>
                  </div>
                  {/* chevron right */}
                  <svg
                    className="mm-cat-chevron"
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="9 18 15 12 9 6" />
                  </svg>
                </div>
              );
            })
          )}
        </nav>

        {/* ── RIGHT: Subcategory Panel ── */}
        <section className="mm-content" aria-label="Subcategories">
          {/* "SHOP BY WOMEN CATEGORY" header */}
          <div className="mm-content-head">
            <div className="mm-content-head-icon">
              {/* grid dots icon (matches reference) */}
              <svg
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <rect x="2" y="2" width="5" height="5" rx="1" />
                <rect x="9.5" y="2" width="5" height="5" rx="1" />
                <rect x="17" y="2" width="5" height="5" rx="1" />
                <rect x="2" y="9.5" width="5" height="5" rx="1" />
                <rect x="9.5" y="9.5" width="5" height="5" rx="1" />
                <rect x="17" y="9.5" width="5" height="5" rx="1" />
                <rect x="2" y="17" width="5" height="5" rx="1" />
                <rect x="9.5" y="17" width="5" height="5" rx="1" />
                <rect x="17" y="17" width="5" height="5" rx="1" />
              </svg>
            </div>
            <h2 className="mm-content-head-title">{headTitle}</h2>
          </div>

          {/* Loading skeleton grid */}
          {loading ? (
            <div className="mm-sub-grid">
              {[1, 2, 3, 4, 5, 6].map((i) => (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 8,
                  }}
                >
                  <div className="mm-skel-circle" />
                  <div
                    className="mm-skel-line"
                    style={{ width: 60, height: 10 }}
                  />
                </div>
              ))}
            </div>
          ) : displaySubs.length === 0 ? (
            <div className="mm-empty">
              <div className="mm-empty-icon">🔬</div>
              <p>No subcategories found for this category.</p>
            </div>
          ) : (
            <>
              <div className="mm-sub-grid">
                {/* "View All" tile — always first */}
                <Link
                  className="mm-sub-tile mm-sub-tile--all"
                  to={
                    activeCatObj
                      ? `/shop?category=${encodeURIComponent(activeCatObj.title || activeCatObj.name)}`
                      : "/shop"
                  }
                  aria-label="View all subcategories"
                >
                  <div className="mm-sub-circle mm-sub-circle--all">
                    <div className="mm-sub-circle--all-inner">
                      {/* "View All" eye icon */}
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                        <circle cx="12" cy="12" r="3" />
                      </svg>
                      <span className="mm-sub-circle--all-text">ALL</span>
                    </div>
                  </div>
                  <span className="mm-sub-label">View All</span>
                </Link>

                {/* Subcategory tiles */}
                {displaySubs.slice(0, 11).map((sub, i) => {
                  const imgSrc =
                    sub.images?.[0]?.secure_url ||
                    sub.image?.[0]?.secure_url ||
                    sub.image?.[0]?.url ||
                    null;

                  return (
                    <Link
                      key={sub._id || i}
                      className="mm-sub-tile"
                      to={`/shop?subcategory=${encodeURIComponent(sub.title || sub.name)}`}
                      aria-label={sub.title || sub.name}
                    >
                      <div
                        className={`mm-sub-circle${!imgSrc ? " mm-sub-circle--icon" : ""}`}
                      >
                        {imgSrc ? (
                          <img
                            src={imgSrc}
                            alt={sub.title || sub.name}
                            loading="lazy"
                            onError={(e) => {
                              e.target.style.display = "none";
                              e.target.parentElement.classList.add(
                                "mm-sub-circle--icon",
                              );
                            }}
                          />
                        ) : (
                          <span style={{ fontSize: "28px" }}>
                            {getIconForCategory(sub.title || sub.name)}
                          </span>
                        )}
                      </div>
                      <span className="mm-sub-label">
                        {sub.title || sub.name}
                      </span>
                    </Link>
                  );
                })}
              </div>

              {/* Footer row */}
              <div className="mm-view-all-wrap">
                <span className="mm-count-badge">
                  {displaySubs.length} subcategories
                </span>
                <Link
                  to={
                    activeCatObj
                      ? `/shop?category=${encodeURIComponent(activeCatObj.title || activeCatObj.name)}`
                      : "/shop"
                  }
                  className="mm-view-all-btn"
                >
                  View All
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="9 18 15 12 9 6" />
                  </svg>
                </Link>
              </div>
            </>
          )}
        </section>
      </div>
    </>
  );
}

export default Hederdisp;
